import Breadcrumb from '../ui/Breadcrumb';

export default function PlaceholderPage({ title, subtitle }) {
  return (
    <div className="Page">
      <header className="PageHeader">
        <div className="PageHeaderBar">
          <Breadcrumb items={[{ label: title }]} />
        </div>
        {subtitle ? <p className="Muted">{subtitle}</p> : null}
      </header>
      <div className="Card">
        <div className="TileBody">Module en cours de mise en place.</div>
      </div>
    </div>
  );
}
